/* eslint-disable @typescript-eslint/ban-types */
/**
 *  ===============================================================================================
 *     ____ _____ _   _          _______     __                 _____           _     _    _
 *    |  _ \_   _| \ | |   /\   |  __ \ \   / /                / ____|         | |   | |  | |
 *    | |_) || | |  \| |  /  \  | |__) \ \_/ /__  _ __   ___  | |  __ _ __ ___ | |__ | |__| |
 *    |  _ < | | | . ` | / /\ \ |  _  / \   / _ \| '_ \ / _ \ | | |_ | '_ ` _ \| '_ \|  __  |
 *    | |_) || |_| |\  |/ ____ \| | \ \  | | (_) | | | |  __/ | |__| | | | | | | |_) | |  | |
 *    |____/_____|_| \_/_/    \_\_|  \_\ |_|\___/|_| |_|\___|  \_____|_| |_| |_|_.__/|_|  |_|
 *
 *  ===============================================================================================
 * @author BINARY one GmbH
 * @license Unlicensed
 */
import '/src/scss/index.scss';
//in your `main.js` file
import { BASEURL, SITEURL } from '@libTs/cms.globals';

import { createApp } from 'vue';
import { initAnimations } from './animations/index';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Component imports
import Hamburger from './components/Hamburger.vue';
import Hero from './components/Hero.vue';
import Button from './components/button.vue';
import ScrollingHeader from './components/ScrollingHeader.vue';
import Accordion from './components/Accordion.vue';
import HoursItem from './components/accordionItems/HoursItem.vue';
import AddressItem from './components/accordionItems/AddressItem.vue';
import Gallery from './components/Gallery.vue';
import NewsPreview from './components/NewsPreview.vue';
import Register from './components/Register.vue';
import BusinessSearch from './components/BusinessSearch.vue';
import BusinessCard from './components/BusinessCard.vue';
// Directive imports

// Service imports

// -----------------------------------------------------------
// DEBUG output
const ISDEBUG = import.meta.env.DEV;

if (ISDEBUG) {
  console.group('Environment loaded');
  console.log(ISDEBUG);
  console.log(
    ' -----------------------------------\n',
    ` BASEURL:\t\t${BASEURL}\n`,
    ` SITEURL:\t\t${SITEURL}\n`,
    '-----------------------------------',
  );
  console.groupEnd();
}

const app = createApp({
  setup() {},
  data() {
    return {};
  },
  provide() {
    return {};
  },
  components: {
    Hamburger: Hamburger,
    Hero: Hero,
    Btn: Button,
    ScrollingHeader: ScrollingHeader,
    Accordion: Accordion,
    AddressItem: AddressItem,
    HoursItem: HoursItem,
    Gallery: Gallery,
    NewsPreview: NewsPreview,
    Register: Register,
    BusinessSearch: BusinessSearch,
    BusinessCard: BusinessCard,
  },
  directives: {},
  mounted() {
    initAnimations();

    window.addEventListener('load', () => {
      ScrollTrigger.refresh();
    });

    document.fonts?.ready.then(() => {
      ScrollTrigger.refresh();
    });
  },
});

app.mount('#app');
